import { Controller } from "@hotwired/stimulus"

// Handles mobile sidebar open/close toggle.
// Connects to data-controller="sidebar" on the main layout wrapper.
export default class extends Controller {
  static targets = ["menu", "overlay"]

  open() {
    this.menuTarget.classList.remove("-translate-x-full")
    this.menuTarget.classList.add("translate-x-0")
    this.overlayTarget.classList.remove("hidden")
  }

  close() {
    this.menuTarget.classList.add("-translate-x-full")
    this.menuTarget.classList.remove("translate-x-0")
    this.overlayTarget.classList.add("hidden")
  }
}
